import { Component, OnInit } from '@angular/core';
import { Routes,Router,RouterModule}  from '@angular/router';
import { CommonService } from '../../services/common.service';
import { AppSettings } from '../../appSettings';

import { LoginService } from '../../services/login.service';
import Swal from 'sweetalert2'
declare var jquery:any;
declare var $ :any;


@Component({
  selector: 'app-manageecrequest',
  templateUrl: './manageecrequest.component.html',
  styleUrls: ['./manageecrequest.component.css']
})
export class ManageecrequestComponent implements OnInit {

  getregistedexchangecentersRestApiUrl:string = AppSettings.get_registed_exchange_centers; 
  enquirylist:Array<Object>;
  model:any={};
  modalData:any={};
  constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router) { }

  ngOnInit() {
    this.loginService.localStorageData();
    this.loginService.viewsActivate();

    this.model.usergroup=localStorage.getItem('currentUsergroup');
    if(this.model.usergroup==2)
    {
      this.loginService.logout();
    }


    let user_id = localStorage.getItem('currentUserID');
    this.model.imagePath = AppSettings.API_BASE;
    this.model.usergroup=localStorage.getItem('currentUsergroup');
    
    this.CommonService.getdata(this.getregistedexchangecentersRestApiUrl)
    .subscribe(det =>{
        if(det.exchangeCentersList!="")
        { 
          this.enquirylist=det.exchangeCentersList;
          console.log('enquirylist-->',det.exchangeCentersList);
          this.loginService.viewCommontdataTable('category_table','category_table');
        } 
          
    });
        
  }

  openModal(modalId:any,modalData:any)
  {
    this.modalData=modalData;
    $('#ecRequestModal').modal('show');
  }

  approveRequest(status:any,modalData:any)
  {
    this.modalData.action=status;
    this.modalData.user_id=modalData.Id;

      Swal.fire({
              title: 'Are You Sure to Update the Status?',
              type: 'success',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Update Now?'
            }).then((result) => {
              if (result.value) {
                this.CommonService.insertdata(AppSettings.approve_reject_exchange_center,this.modalData)
                .subscribe(det =>{  
                  console.log(det);
                  if(det.status==1){
                    swal("Success",det.message,"success");
                    
                  }else{
                    swal("Ops!",det.message,"error");
                  }
                     
                  $('#ecRequestModal').modal('hide'); 
                  
                }); 
                this.ngOnInit(); 
                this.router.navigate(['/manageecrequest']);
              }
            })
    
    
  } 

  openImageFullscreen(imageUrl: string) {
    // Open image in new window for fullscreen view
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Fullscreen Image</title>
          <style>
            body {
              margin: 0;
              padding: 20px;
              background-color: #000;
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 100vh;
              font-family: Arial, sans-serif;
            }
            .image-container {
              position: relative;
              max-width: 100%;
              max-height: 100%;
            }
            .fullscreen-img {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
              border-radius: 8px;
              box-shadow: 0 4px 20px rgba(255,255,255,0.1);
            }
            .close-btn {
              position: fixed;
              top: 20px;
              right: 20px;
              background: rgba(255,255,255,0.2);
              border: none;
              color: white;
              font-size: 24px;
              padding: 10px 15px;
              border-radius: 50%;
              cursor: pointer;
              z-index: 1000;
              transition: background 0.3s ease;
            }
            .close-btn:hover {
              background: rgba(255,255,255,0.3);
            }
            .image-title {
              position: fixed;
              bottom: 20px;
              left: 50%;
              transform: translateX(-50%);
              color: white;
              background: rgba(0,0,0,0.7);
              padding: 10px 20px;
              border-radius: 25px;
              font-size: 14px;
            }
          </style>
        </head>
        <body>
          <button class="close-btn" onclick="window.close()">&times;</button>
          <div class="image-container">
            <img src="${imageUrl}" class="fullscreen-img" alt="Fullscreen Document">
          </div>
          <div class="image-title">Click × to close</div>
          <script>
            // Close on escape key
            document.addEventListener('keydown', function(e) {
              if (e.key === 'Escape') {
                window.close();
              }
            });
            
            // Close when clicking outside image
            document.addEventListener('click', function(e) {
              if (e.target === document.body || e.target.className === 'fullscreen-img') {
                window.close();
              }
            });
          </script>
        </body>
        </html>
      `);
      newWindow.document.close();
    }
  }


}
